<app-breadcrumb [title]="'profile'|translate" [items]="['security'|translate]" [active_item]="'profile'|translate"></app-breadcrumb>

<div class="container-fluid">
  <div class="edit-profile">

      <div class="col-xl-8">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title mb-3 f-w-700">{{ 'profile configuration'|translate }}</h5>
            <div class="card-options">

                <form class="row" [formGroup]="roleForm" (ngSubmit)="onFormSubmit()" id="ngForm">

                    <div class="col-md-12 mb-3">
                        <input readonly="readonly" class="form-control form-control-sm" type="text" placeholder="Ex. Admin" formControlName="name" [ngClass]="{'is-invalid': fc['name'].invalid && isSubmitted}">
                        <small class="invalid-feedback fst-italic" *ngIf="fc['name'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                        <div class="invalid-feedback" *ngIf="fc['name'].errors?.['serverError']">
                            {{ fc['name'].errors?.['serverError'] }}
                        </div>
                    </div>

                    <button form="ngForm" (submit)="onFormSubmit()" type="submit" class="btn btn-sm btn-primary" [disabled]=saving>
                        <ng-container *ngIf="!saving; else isSaving">{{data ? update : create}}</ng-container>
                        <ng-template #isSaving>
                            {{ "submitting" | translate }} ...
                        </ng-template>
                    </button>

                </form>

            </div>
          </div>

          <div class="card-body">

            <div class="row">
              <div class="col-md-12">
                <h6>Search</h6>
                <ngx-treeview [config]="config" [items]="items" (selectedChange)="onSelectedChange($event)">
                </ngx-treeview>
              </div>

            </div>

          </div>


        </div>
      </div>


<!--  <button form="ngForm" (submit)="onFormSubmit()" type="submit" class="btn btn-sm btn-outline-primary" [disabled]=saving>-->
<!--    <ng-container *ngIf="!saving; else isSaving">{{data ? update : create}}</ng-container>-->
<!--    <ng-template #isSaving>-->
<!--      {{ "Submitting" | translate}} ...-->
<!--    </ng-template>-->
<!--  </button>-->

</div>
